import React, { useState, useEffect } from "react";
import "./remove-bank-account.scss";
import { GSForm, GSSidePanelPage, GSInfoGroup, GSField } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { removeItemForm, getRemoveTitle } from "../../forms/DeleteForm";

import {
  selectCurrentOrganization,
  selectOrganizationBankAccount,
  removeOrganizationBankAccount,
  clearNotifications,
  selectOrganizationNotifications,
} from "../../reducers/organizationSlice";
import { useNotificationBanner } from "../../hooks/notificationHooks";

const RemoveBankAccount = () => {
  const [isValid, setIsValid] = useState(false);
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const bankAccount = useSelector(selectOrganizationBankAccount);
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const removeBankAccount = () => {
    if(bankAccount?.accountLastFour) {
      setIsValid(false);
      dispatch(removeOrganizationBankAccount(selectedOrganization.id));
    }
  }

  const leftNavigation = () => {
    navigate(-1);
  };

  useEffect(() => {
    if(bankAccount?.accountLastFour) {
      setIsValid(true);
    } else if (!bankAccount?.accountLastFour) {
      // this allows for it to automatically go back to the previous page if bank account successfully removed
      navigate(-1);
    }
  }, [bankAccount?.accountLastFour, navigate]);

  const getActions = () => {
    let actions = [
      {
        name: "disconnect",
        action: removeBankAccount,
        isDisabled: !isValid,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Disconnect Bank Account",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getInfoGroup = (accountLastFour) => {
    const group = [
      {
        fit: "stretch",
        sections: [
          {
            sectionItems: [
              { type: "secondary", value: <GSField label="bank account" value={`Ending in *${accountLastFour}`} /> },
            ],
          },
        ],
      },
    ];
    
    return group;
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getRemoveTitle("Disconnect Bank Account")}
        formSections={
          removeItemForm("bank account",
          <GSInfoGroup dataGroups={getInfoGroup(bankAccount?.accountLastFour)} />,
          "disconnect",
          `Are you sure you want to disconnect this bank account? This cannot be undone.`
        )}
      />
    );
  };
  
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to details",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  const [banner] = useNotificationBanner(
    {
      notifications: orgNotifications.map((n) => ({
      ...n,
      pageActions: getBannerActions(),
    })), timeoutAction});

  return (
    <remove-bank-account>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      />
    </remove-bank-account>
  );
};

export default RemoveBankAccount;
